import http from './_http'

const group = {
  get: (id) => http.get(`api.user/member/group/${id}`),
  update: (m) => http.put(`api.user/member/group`, m),
}
const user = {
  get: (id) => http.get(`api.user/member/user/${id}`),
  list: (m) => http.post(`api.user/member/users/search`, m),
  write: (m) => http.post(`api.user/member/user`, m),
  update: (id, m) => http.put(`api.user/member/user/${id}`, m),
  delete: (id) => http.delete(`api.user/member/user/${id}`),
  permissions: (id, perm) => http.patch(`api.user/member/user/${id}/permissions`, perm),
  enable: (id) => http.patch(`api.user/member/user/${id}/enable`),
  disable: (id) => http.patch(`api.user/member/user/${id}/disable`),
}
const User = (m) => { return http.post(`/user`, m) }
const User_Call = (a, b, c) => User({ target: a, cmd : b, body : c });
const Manager = (m) => { return http.post(`/manager`, m) }
const Manager_Call = (a, b, c) => Manager({ target: a, cmd : b, body : c });
const member  = {
  group, user, Manager, Manager_Call, User, User_Call
}
export default member
export { group, user, User, User_Call, Manager, Manager_Call }